fragment EmailSequenceTemplate on EmailSequenceTemplate {
    id
    name
    lastSentTime
    isShared
    isImmutable
    isArchived
    canEdit
    deletedTime
    group {
        id
        name
    }
    replyRate
    replyCount
    clickRate
    clickCount
    cancelledCount
    finishedCount
    inProgressCount
    startedWithClickTrackingCount
    emailAutomation {
        id
        entersStage {
            id
            stageset {
                id
                name
            }
        }
    }
    userChildSequenceTemplate {
        id
    }
    emailSequenceTemplateMessages {
        id
        emailTemplate {
            id
        }
    }
    creatorUser {
        id
        name
    }
}
